<div
  edsGrid
  [edsSpacing]="(isHandheld$ | async) === false ? 'xxxl' : 'xxl'"
  edsPadding
  [edsPaddingLeft]="(isHandheld$ | async) ? 'sm' : 'none'"
  [edsPaddingRight]="(isHandheld$ | async) ? 'sm' : 'none'"
>
  <ng-container *ngIf="cartItems$ | async as cartItems">
    <div *ngIf="cartItems.cartItems.length; else showEmptyMsg">
      <section
        [edsSpacing]="(isHandheld$ | async) ? 'md' : 'lg'"
        edsPadding
        [edsPaddingLeft]="(isHandheld$ | async) ? 'sm' : 'none'"
      >
        <div edsGrid>
          <!-- breadcrumbs  area -->
          <eds-breadcrumbs
            [items]="showBreadcrumb ? breadcrumbItems : null"
            theme="basic"
            edsPadding
            edsPaddingLeft="sm"
          >
          </eds-breadcrumbs>
          <div class="container" edsPadding edsPaddingTop="lg">
            <!-- Order Success -->
            <p edsSpacing="xs" class="pre-title">
              {{ "literature.order-confirm-title" | translate }}
            </p>
            <eds-title
              edsSpacing="xs"
              title="{{ 'literature.mail-title-confirm-order' | translate }}"
              size="h2"
              theme="basic"
              [level]="1"
              [isLight]="true"
            ></eds-title>
            <eds-title
              edsSpacing="none"
              title="{{
                'literature.mail-title-confirm-order-description' | translate
              }}"
              size="h6"
              theme="basic"
              [level]="3"
              [isLight]="true"
            ></eds-title>
          </div>
        </div>
      </section>
      <div class="container">
        <p>{{ "literature.order-information" | translate }}</p>
        <div
          edsFlexbox
          [flexDirection]="(isMobile$ | async) ? 'column' : 'row'"
          justifyContent="space-between"
          edsSpacing="xl"
        >
          <div
            edsFlexItem
            flexBasis="40%"
            [edsSpacing]="(isMobile$ | async) ? 'lg' : 'none'"
          >
            <eds-title
              edsSpacing="sm"
              title="{{ 'literature.mail-title-mailing-address' | translate }}"
              size="h6"
              theme="basic"
            ></eds-title>
            <address>
              <p edsSpacing="none">
                {{ orderFormDetailsValue?.firstName }}
                {{ orderFormDetailsValue?.lastName }}<br />
                {{ orderFormDetailsValue?.addressLine1 }}
                {{ orderFormDetailsValue?.addressLine2 }}<br />
                {{ orderFormDetailsValue?.city }}<br />
                {{ stateName }}<br />
                {{ orderFormDetailsValue?.zip }}
              </p>
            </address>
          </div>
          <div edsFlexItem flexBasis="60%">
            <eds-title
              edsSpacing="sm"
              title="{{ 'literature.mail-title-delivery-detail' | translate }}"
              size="h6"
              theme="basic"
            ></eds-title>
            <ng-container *ngIf="isPrimericaUser; else nonPrimericaUser">
              <div
                innerHtml="{{
                  'literature.lit-mail-order-detail-delivery-information-primerica'
                    | translate
                }}"
              ></div>
            </ng-container>
            <ng-template #nonPrimericaUser>
              <div
                innerHtml="{{
                  'literature.lit-mail-order-detail-delivery-information'
                    | translate
                }}"
              ></div>
            </ng-template>

            <div edsFlexbox alignItems="center">
              <eds-link-item
                title="{{ 'literature.lit-edit' | translate }}"
                (click)="editData($event)"
              >
              </eds-link-item>
              <p
                edsSpacing="none"
                edsPadding
                edsPaddingRight="xs"
                edsPaddingLeft="xs"
              >
                {{ "literature.or" | translate }}
              </p>
              <eds-link-item
                title="{{ 'literature.lit-cancel-order' | translate }}"
                (click)="openConfirmMoadal($event, 'cancelOrder')"
              >
              </eds-link-item>
            </div>
          </div>
        </div>
        <p>{{ "literature.order-details" | translate }}</p>
        <ng-container *ngIf="cartItems$ | async as cartItems">
          <div
            edsFlexbox
            [flexDirection]="(isMobile$ | async) === false ? 'row' : 'column'"
            justifyContent="space-between"
          >
            <div edsFlexbox>
              <p edsPadding edsPaddingRight="sm" edsSpacing="md">
                {{ "literature.cart-total-items" | translate }} :
                {{ cartItems.cartItems.length }}
              </p>
              <p class="separator"></p>
              <p edsPadding edsPaddingLeft="sm" edsSpacing="md">
                {{ "literature.overall-quantity" | translate }} :
                {{ getOverAllQty(cartItems.cartItems) }}
              </p>
            </div>
            <div>
              <eds-link-item
                (click)="openConfirmMoadal($event, 'emptyCart')"
                title="{{ 'literature.empty-cart' | translate }}"
                edsSpacing="md"
              ></eds-link-item>
            </div>
          </div>
          <div edsGrid edsSapcing="lg">
            <div edsRow>
              <table
                class="table table--secondary"
                #tableResponsive
                [style.display]="(isHandheld$ | async) ? 'none' : ''"
              >
                <thead class="table__thead">
                  <tr class="table__tr">
                    <th class="table__th">
                      {{ "literature.lit-listing-items" | translate }}
                    </th>
                    <th class="table__th text-align-right">
                      {{ "literature.client-use" | translate }}
                    </th>
                    <th class="table__th text-align-right">
                      {{ "literature.quantity" | translate }}
                    </th>
                  </tr>
                </thead>
                <tbody class="table__body">
                  <tr
                    class="table__tr"
                    *ngFor="let data of cartItems.cartItems"
                  >
                    <td class="table__td">
                      <div edsFlexbox>
                        <div>
                          <eds-link-item
                            edsSpacing="md"
                            [title]="data.dctermsTitle"
                            [href]="getLiteratureDetailLink(data.docId)"
                          ></eds-link-item>
                        </div>
                      </div>
                    </td>
                    <td class="table__td text-align-right">
                      {{ data.clientUse }}
                    </td>
                    <td class="table__td text-align-right">
                      {{ data.quantity }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div edsRow *ngFor="let card of cards; let cardIndex = index">
              <div edsCol *ngIf="isHandheld$ | async">
                <eds-panel
                  edsSpacing="sm"
                  [hasBorders]="true"
                  [hasBorderRadius]="true"
                  [hasPadding]="true"
                >
                  <ng-container
                    *ngFor="let item of card; let itemIndex = index"
                  >
                    <eds-info-item
                      *ngIf="itemIndex !== 0"
                      [info]="item"
                      edsSpacing="sm"
                    >
                    </eds-info-item>
                    <ng-container *ngIf="itemIndex === 0">
                      <eds-info-item [info]="item" edsSpacing="sm">
                        {{ removeAndGetLinkValue(item) }}
                        <eds-link-item
                          edsSpacing="sm"
                          [title]="cartItems.cartItems[cardIndex].dctermsTitle"
                          [href]="
                            getLiteratureDetailLink(
                              cartItems.cartItems[cardIndex].docId
                            )
                          "
                        >
                        </eds-link-item>
                      </eds-info-item>
                    </ng-container>
                  </ng-container>
                </eds-panel>
              </div>
            </div>
          </div>
          <div edsFlexbox>
            <div edsPadding edsPaddingRight="sm">
              <button
                edsButton="secondary"
                size="normal"
                [noMargin]="true"
                (click)="navigateToMailAdress()"
              >
                <span>{{ "literature.mail-back-button" | translate }}</span>
              </button>
            </div>
            <button
              edsButton="primary"
              size="normal"
              [noMargin]="true"
              (click)="placeOrder(cartItems)"
              [disabled]="isSubmitOrderClicked"
            >
              <span>{{
                "literature.mail-submit-order-button" | translate
              }}</span>
            </button>
          </div>
        </ng-container>
      </div>
    </div>

    <ng-template #showEmptyMsg>
      <section
        [edsSpacing]="(isHandheld$ | async) ? 'md' : 'lg'"
        edsPadding
        [edsPaddingLeft]="(isHandheld$ | async) ? 'sm' : 'none'"
      >
        <div edsGrid>
          <!-- breadcrumbs  area -->
          <eds-breadcrumbs
            [items]="showBreadcrumb ? breadcrumbItems : null"
            theme="basic"
            edsPadding
            edsPaddingLeft="sm"
          >
          </eds-breadcrumbs>
          <div class="container" edsPadding edsPaddingTop="lg">
            <!-- Order Success -->
            <p edsSpacing="xs" class="pre-title">
              {{ "literature.order-confirm-title" | translate }}
            </p>
            <p edsSpacing="xs">
              {{ "literature.no-items" | translate }}
              <a
                (click)="goToLiterature()"
                [ngStyle]="{
                  cursor: 'pointer'
                }"
              >
                <span>{{ "literature.literature" | translate }}</span>
              </a>
              {{ "literature.select-materials" | translate }}
            </p>
          </div>
        </div>
      </section>
    </ng-template>
  </ng-container>
</div>

<ft-literature-dialog
  [dialogId]="operationType"
  [modalIdEnum]="'cartModal'"
  (dialog)="closeModal('cartModal', $event)"
  (emptyCart)="cancelOrder()"
  (modalClose)="closeModal('cartModal', $event)"
></ft-literature-dialog>
